import { render, staticRenderFns } from "./TariffFact.vue?vue&type=template&id=aeea5914&"
import script from "./TariffFact.vue?vue&type=script&lang=js&"
export * from "./TariffFact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports